//截取url值
function getUrlKey(name) {
	return (
		decodeURIComponent(
			(new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
				location.href
			) || ["", ""])[1].replace(/\+/g, "%20")
		) || null
	);
}

/**
 *获取几个月前的输入日期
 *{param:DateTime} date 输入日期(YYYY-MM-DD)
 *{param:number } monthNum 月数
 */
function GetPreMonthDay(date, monthNum) {
	var dateArr = date.split("-");
	var year = dateArr[0]; //获取当前日期的年份
	var month = dateArr[1]; //获取当前日期的月份
	var year2 = year;
	var month2 = parseInt(month) - monthNum;
	if (month2 <= 0) {
		var absM = Math.abs(month2);
		year2 =
			parseInt(year2) - Math.ceil(absM / 12 == 0 ? 1 : parseInt(absM) / 12);
		month2 = 12 - (absM % 12);
	}
	if (month2 < 10) {
		month2 = "0" + month2;
	}
	var t2 = year2 + "-" + month2;
	return t2;
}

//参数 进行格式化
function getParams(params) {
	let str = "";
	let objs = Object.keys(params);
	objs.forEach((item, index) => {
		str = str + `${item}=${params[item]}`;
		if (index != objs.length - 1) {
			str = str + "&";
		}
	});
	return str;
}

//file 转base64
function getBase64(file, callback) {
	let reader = new FileReader();
	let img = new Image();
	img.src = file.url;
	reader.readAsDataURL(file.raw);
	reader.onload = function() {
		callback({
			base64: reader.result.split("base64,")[1],
			type: img.width > img.height ? "horizontal" : "vertical",
		});
	};
}
//保留[keyNum]位小数(不进行四舍五入)
function KeepDecimalPoint(value, keyNum) {
	if (isNaN(Number(value))) {
		throw new Error(`传入的值:${value},不是数字`)
	}
	value = value + ''
	console.log(value);
	let index = value.indexOf('.')
	return parseFloat(value.substring(0, index + 1 + keyNum))
}
/*
 *@Author: 史泽
 *@Date: 2022-01-12 14:11:10
 *@Description: 获取年月日
 */
function getDate() {
	let date = new Date();
	let year = date.getFullYear();
	let month =
		date.getMonth() + 1 >= 10 ?
		date.getMonth() + 1 :
		"0" + (date.getMonth() + 1);
	let day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();
	return `${year}-${month}-${day}`;
}
/*
 *@Author: 史泽
 *@Date: 2022-02-26 12:36:55
 *@Description: 获取年月日时分秒毫秒
 */
function getDateTime() {
	let Time = new Date();
	let Year = Time.getFullYear();
	let Month =
		Time.getMonth() + 1 < 10 ?
		"0" + (Time.getMonth() + 1) :
		Time.getMonth() + 1;
	let Day = Time.getDay() < 10 ? "0" + Time.getDay() : Time.getDay();
	let Hour = Time.getHours() < 10 ? "0" + Time.getHours() : Time.getHours();
	let Second =
		Time.getSeconds() < 10 ? "0" + Time.getSeconds() : Time.getSeconds();
	let Minute =
		Time.getMinutes() < 10 ? "0" + Time.getMinutes() : Time.getMinutes();
	return `${Year}-${Month}-${Day} ${Hour}:${Minute}:${Second}`;
}

/*
 *@Author: 史泽
 *@Date: 2022-01-12 14:10:52
 *@Description: 格式化金钱
 */
function parseMoney(num) {
	if (num && num != null) {
		num = String(num);
		var left = num.split(".")[0],
			right = num.split(".")[1];
		right = right ?
			right.length >= 2 ?
			"." + right.substr(0, 2) :
			"." + right + "0" :
			".00";
		var temp = left
			.split("")
			.reverse()
			.join("")
			.match(/(\d{1,3})/g);
		return (
			(Number(num) < 0 ? "-" : "") +
			temp
			.join(",")
			.split("")
			.reverse()
			.join("") +
			right
		);
	} else if (num === 0) {
		return "0.00";
	} else {
		return "";
	}
}

/*
 *@Author: 史泽
 *@Date: 2022-01-12 14:10:44
 *@Description: 下载文件
 */
function downloadFile(file, name = "我是文件", type, typeFile, callback) {
	const blob = new Blob([file], {
		type: typeFile
	});
	const fileName = `${name}.${type}`;
	if (!callback) {
		const linkNode = document.createElement("a");
		linkNode.download = fileName; //a标签的download属性规定下载文件的名称
		linkNode.style.display = "none";
		linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
		document.body.appendChild(linkNode);
		linkNode.click(); //模拟在按钮上的一次鼠标单击
		URL.revokeObjectURL(linkNode.href); // 释放URL 对象
		document.body.removeChild(linkNode);
	} else {
		callback(URL.createObjectURL(blob));
	}
}
/*
 *@Author: 史泽
 *@Date: 2022-03-21 16:05:35
 *@Description: PDF使用流打印
 */
function downloadFilePdfStream(res, type) {
	const content = res;
	console.log(res, 'res');
	// 主要的是在这里的转换，必须要加上{ type: 'application/pdf' }
	// 要不然无法进行打印
	const blob = new Blob([content], {
		type: type
	});
	var date = new Date().getTime();
	var ifr = document.createElement("iframe");
	ifr.style.frameborder = "no";
	ifr.style.display = "none";
	ifr.style.pageBreakBefore = "always";
	ifr.setAttribute("id", "printPdf" + date);
	ifr.setAttribute("name", "printPdf" + date);
	ifr.src = window.URL.createObjectURL(blob);
	document.body.appendChild(ifr);
	var ordonnance = document.getElementById("printPdf" + date).contentWindow;
	setTimeout(() => {
		// window.print()
		ordonnance.print();
		this.pdfLoading = false;
	}, 100);
	window.URL.revokeObjectURL(ifr.src); // 释放URL 对象
}

/*
 *@Author: 史泽
 *@Date: 2022-03-23 11:58:00
 *@Description: 文件流转换URL
 *@param: file: 文件流
 */
// 将返回的流数据转换为url
function getObjectURL(file) {
	let url = null;
	if (window.createObjectURL != undefined) {
		// basic
		url = window.createObjectURL(file);
	} else if (window.webkitURL != undefined) {
		// webkit or chrome
		try {
			url = window.webkitURL.createObjectURL(file);
		} catch (error) {}
	} else if (window.URL != undefined) {
		// mozilla(firefox)
		try {
			url = window.URL.createObjectURL(file);
		} catch (error) {}
	}
	return url;
}
//获取 多少天前或者多少天后
function getNextDate(num) {
	var date1 = new Date();
	//今天时间
	var time1 =
		date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate();
	////console.log(time1);
	var date2 = new Date(date1);
	date2.setDate(date1.getDate() + num);
	//num是正数表示之后的时间，num负数表示之前的时间，0表示今天
	var time2 =
		date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate();
	////console.log(time2);
	return time2;
}
// 对象数组去重
function deteleObject(obj) {
	var uniques = [];
	var stringify = {};
	for (var i = 0; i < obj.length; i++) {
		var keys = Object.keys(obj[i]);
		keys.sort(function(a, b) {
			return Number(a) - Number(b);
		});
		var str = "";
		for (var j = 0; j < keys.length; j++) {
			str += JSON.stringify(keys[j]);
			str += JSON.stringify(obj[i][keys[j]]);
		}
		if (!stringify.hasOwnProperty(str)) {
			uniques.push(obj[i]);
			stringify[str] = true;
		}
	}
	uniques = uniques;
	return uniques;
}
// 数组对象去重
function process(arr, arr2, arrObj) {
	// arr2: 缓存用于记录
	for (const t of arr) {
		// 检查缓存中是否已经存在
		if (arr2.find(c => c.arrObj === t.arrObj)) {
			// 已经存在说明以前记录过，现在这个就是多余的，直接忽略
			continue;
		}
		// 不存在就说明以前没遇到过，把它记录下来
		arr2.push(t);
	}

	// 记录结果就是过滤后的结果
	return arr2;
}
// 删除两个数组重复(1)
function deteleALL1(arr1, arr2) {
	for (var i = 0; i < arr2.length; i++) {
		for (var j = 0; j < arr1.length; j++) {
			if (arr2[i].a == arr1[j].a) {
				arr1.splice(j, 1);
			}
		}
	}
}

// 删除两个数组重复(2)
function deteleALL(arr1, arr2) {
	var set = arr2.map((item) => item.id);
	var resArr = arr1.filter((item) => !set.includes(item.id));
	return resArr;
}
// 格式化json字符串
function formatJson(msg) {
	var rep = "~";
	var jsonStr = JSON.stringify(msg, null, rep);
	var str = "";
	for (var i = 0; i < jsonStr.length; i++) {
		var text2 = jsonStr.charAt(i);
		if (i > 1) {
			var text = jsonStr.charAt(i - 1);
			if (rep != text && rep == text2) {
				str += "<br/>";
			}
		}
		str += text2;
	}
	jsonStr = "";
	for (var i = 0; i < str.length; i++) {
		var text = str.charAt(i);
		if (rep == text) jsonStr += "&nbsp;&nbsp;&nbsp;&nbsp;";
		else {
			jsonStr += text;
		}
		if (i == str.length - 2) jsonStr += "<br/>";
	}
	return jsonStr;
}
/*函数节流*/
function throttle(fn, interval) {
	var enterTime = 0; //触发的时间
	var gapTime = interval || 300; //间隔时间，如果interval不传，则默认300ms
	return function() {
		var context = this;
		var backTime = new Date(); //第一次函数return即触发的时间
		if (backTime - enterTime > gapTime) {
			fn.call(context, arguments);
			enterTime = backTime; //赋值给第一次触发的时间，这样就保存了第二次触发的时间
		}
	};
}

/*函数防抖*/
function debounce(fn, delay) {
	let timer = null

	return function() {

		let content = this;

		let args = arguments;

		if (timer) {

			clearTimeout(timer)

		}

		timer = setTimeout(() => {

			fn.apply(content, args)

		}, delay)

	}
}

//获取年份/季度/月份 索引值
function getDaysIndex() {
	let date = new Date();
	let year = date.getFullYear();
	let month = date.getMonth();
	let quarter = 0;
	if (month >= 0 && month <= 2) {
		quarter = 0;
	} else if (month >= 3 && month <= 5) {
		quarter = 1;
	} else if (month >= 6 && month <= 8) {
		quarter = 2;
	} else if (month >= 9 && month <= 11) {
		quarter = 3;
	}
	return {
		year,
		month,
		quarter
	}
}

/**
 * 解决两个数相加精度丢失问题
 * @param a
 * @param b
 * @returns {Number}
 */
function floatAdd(a, b) {
	var c, d, e;
	if (undefined == a || null == a || "" == a || isNaN(a)) {
		a = 0;
	}
	if (undefined == b || null == b || "" == b || isNaN(b)) {
		b = 0;
	}
	try {
		c = a.toString().split(".")[1].length;
	} catch (f) {
		c = 0;
	}
	try {
		d = b.toString().split(".")[1].length;
	} catch (f) {
		d = 0;
	}
	e = Math.pow(10, Math.max(c, d));
	return (floatMul(a, e) + floatMul(b, e)) / e;
}
/**
 * 解决两个数相减精度丢失问题
 * @param a
 * @param b
 * @returns {Number}
 */
function floatSub(a, b) {
	var c, d, e;
	if (undefined == a || null == a || "" == a || isNaN(a)) {
		a = 0;
	}
	if (undefined == b || null == b || "" == b || isNaN(b)) {
		b = 0;
	}
	try {
		c = a.toString().split(".")[1].length;
	} catch (f) {
		c = 0;
	}
	try {
		d = b.toString().split(".")[1].length;
	} catch (f) {
		d = 0;
	}
	e = Math.pow(10, Math.max(c, d));
	return (floatMul(a, e) - floatMul(b, e)) / e;
}
/**
 * 解决两个数相乘精度丢失问题
 * @param a
 * @param b
 * @returns {Number}
 */
function floatMul(a, b) {
	var c = 0,
		d = a.toString(),
		e = b.toString();
	try {
		c += d.split(".")[1].length;
	} catch (f) {}
	try {
		c += e.split(".")[1].length;
	} catch (f) {}
	return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}
/**
 * 解决两个数相除精度丢失问题
 * @param a
 * @param b
 * @returns
 */
function floatDiv(a, b) {
	var c, d, e = 0,
		f = 0;
	try {
		e = a.toString().split(".")[1].length;
	} catch (g) {}
	try {
		f = b.toString().split(".")[1].length;
	} catch (g) {}
	return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), floatMul(c / d, Math
		.pow(10, f - e));
}


//根据某个字段过滤
function filterObj(arr, val) {
	const res = new Map()
	return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1));
}

//获取产线色值
function getInvColor(inv) {
	let colorEnum = {
		'神经介入': '#E71D43',
		'外周介入': '#002B66',
		'血透通路': '#8A9099'
	}
	return colorEnum[inv];
}

//获取本年1月1号
function getFYearDate() {
	return `${new Date().getFullYear()}-01-01`;
}

export default {
	getUrlKey,
	GetPreMonthDay,
	getDateTime,
	getParams,
	getBase64,
	getDate,
	parseMoney,
	downloadFile,
	getNextDate,
	deteleObject,
	deteleALL,
	process,
	formatJson,
	downloadFilePdfStream,
	getObjectURL,
	throttle,
	debounce,
	KeepDecimalPoint,
	getDaysIndex,
	floatAdd,
	floatSub,
	floatMul,
	floatDiv,
	filterObj,
	getInvColor,
	getFYearDate
};